import { useState } from "react";
import { Link } from "react-router-dom";
import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/cursos-en-espanol/curso-para-multas.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faUser } from "@fortawesome/free-solid-svg-icons";
import "./FourHourBDI.css";

const CursoParaMultas = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = (e) => {
        e.preventDefault();
        window.location.href =
            "https://courses.metrotrafficschool.com/onlinecourses/index.php/login?awc_id=NDc2";
    };

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Curso para multas</h1>
                            <p className="banner-subheading">Escuela de Tráfico</p>
                        </div>
                    </div>
                </div>
            </section >

            <main className="bdi-page mb-3">
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-lg-7 mb-4">
                            <ShellCard>
                                <h3 className="mb-4 text-warning">
                                    Escuela de Tráfico
                                </h3>
                                <h4 className="text-white mb-4">SÓLO - $29.50</h4>

                                <p className="lead mb-3">
                                    Haga nuestro curso y obtenga los siguientes beneficios:
                                </p>

                                <ul className="list-unstyled mb-4">
                                    <li className="mb-2">
                                        Evitar aumento del seguro (estatus 626.9541)
                                    </li>
                                    <li className="mb-2">
                                        No se agregarán puntos en su record de licencia de manejar
                                    </li>
                                    <li className="mb-2">
                                        Mantiene su estatus de buen chofer
                                    </li>
                                </ul>

                                <p className="mb-3">
                                    Para comunicarse con nosotros después de horario de oficina,
                                    fines de semana o días festivos <a href="mailto:info@metrotrafficschool.com" className="text-warning">envíe un correo electrónico</a>.
                                </p>
                                <p className="mb-3">
                                    Incluya su nombre y número de teléfono con un mensaje. Un
                                    representante se pondrá en contacto con usted.
                                </p>
                                <p className="mb-4">
                                    Para matricularse en la clase de 4 horas en español por
                                    Internet llamar al (305) 513-0063 o simplemente registrarse
                                    usted mismo y empiece eliminando sus puntos.
                                </p>

                                <div
                                    className="p-4 rounded mb-4 text-center"
                                    style={{
                                        backgroundColor: "#252525",
                                        borderRadius: "8px",
                                        border: "2px solid var(--metro-yellow)",
                                    }}
                                >
                                    <h3 className="text-white mb-3">Curso para multas</h3>
                                    <div className="mb-3">
                                        <span
                                            className="display-5 fw-bold text-warning"
                                        >
                                            $29.50
                                        </span>
                                    </div>
                                    <p className="text-white mb-3">¡Regístrese en línea y empiece ahora!</p>

                                    <div className="d-flex flex-wrap justify-content-center gap-3">
                                        <a
                                            href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NDc2&_gl=1*1eew1f*_gcl_au*MTU2NDc3NDA3Ni4xNzYzNTY2ODcw"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                            style={{ minWidth: "200px" }}
                                        >
                                            ¡Regístrese Ahora!
                                        </a>
                                    </div>
                                </div>

                                <p className="mb-2">
                                    También ofrecemos clases en persona y en español.
                                </p>
                                <p className="mb-2">Favor de llamar al 1(888) 41-METRO.</p>
                                <p className="mb-4">
                                    Para registrarse y escoger la clase que más le convenga
                                    durante la semana o en el fin de semana en español
                                </p>
                                <p className="mb-4">¡Muchas gracias!</p>

                                <div>
                                    <a
                                        href="/curso-de-4-horas"
                                        className="btn metro-btn-secondary fw-bold"
                                    >
                                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                        Más información
                                    </a>
                                </div>
                            </ShellCard>
                        </div>

                        <div className="col-12 col-lg-5 mb-4">
                            <ShellCard>
                                <h3 className="mb-4 text-warning">
                                    Información de Cómo Entrar en el Sistema
                                </h3>
                                <p className="text-muted mb-4">
                                    Cómo entrar en el sistema de clases de tráfico o de obtener licencia
                                </p>

                                <form onSubmit={handleLogin}>
                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label text-white">
                                            Nombre de Usuario
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="username"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            style={{
                                                backgroundColor: "#333",
                                                border: "1px solid #444",
                                                color: "#fff",
                                            }}
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label htmlFor="password" className="form-label text-white">
                                            Contraseña
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            style={{
                                                backgroundColor: "#333",
                                                border: "1px solid #444",
                                                color: "#fff",
                                            }}
                                        />
                                    </div>
                                    <div className="d-grid">
                                        <button
                                            type="submit"
                                            className="btn metro-btn-secondary fw-bold text-uppercase"
                                        >
                                            Login
                                        </button>
                                    </div>
                                </form>
                            </ShellCard>
                        </div>
                    </div>
                    <div className="row p-3">
                        <p>Superb Customer Service</p>
                        <p>At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!</p>
                    </div>
                </div>
            </main>
        </>
    );
};

export default CursoParaMultas;
